import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Live agent inventories. Every call goes out to Atera / Wazuh, so these are
// deliberately NOT cached: the whole point is to enrol a machine and refresh
// until it shows up. staleTime 0 and no background refetch — the user decides
// when to ask, with the Refresh button.

export function useAteraAgents() {
  return useQuery({
    queryKey: ['agents', 'atera'],
    queryFn: async () => (await api.get('/api/devices/agents/atera')).data,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}

export function useWazuhAgents() {
  return useQuery({
    queryKey: ['agents', 'wazuh'],
    queryFn: async () => (await api.get('/api/devices/agents/wazuh')).data,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}
